<template>
  <div>
    <div class="row my-2">
      <div class="col-sm-6 col-6">
        <save-link-button></save-link-button>
      </div>
      <div class="col-sm-6 col-6">
        <dm-button v-if="$store.state.dm" :showFromPage="4"></dm-button>
        <request-pdf-buton v-else :showFromPage="4"></request-pdf-buton>
      </div>
    </div>
    <collapsible
      class="alert alert-dark mb-5"
      :transitionDuration="'500ms'"
      :isOpen="false"
      :transitionTimingFunction="'ease-in-out'"
      :openLabel="'Nyitva'"
    >
      <div slot="trigger">
        <div class="row">
          <div class="text-white col-sm-8">
            <u>
              Részletek Elrejtése
            </u>
          </div>
          <b class="col-sm-4">
            <div class="arrow-up" role="button" title="Részletek bezárása"></div>
          </b>
        </div>
      </div>
      <div slot="closedTrigger">
        <div class="row">
          <div class="text-white col-sm-8">
            <u>
              Részletek
            </u>
          </div>
          <b class="col-sm-4">
            <div class="arrow-down" role="button" title="Részletek lenyitása"></div>
          </b>
        </div>
        <div class="col-md-8">
          <div class="form-group row mb-2">
            <label class="col-sm-6 fw-bold" for="eves_alapdij">A biztosítás éves alapdíja kedvezmények nélkül:</label>
            <div class="col-sm-6">
              <input
                id="eves_alapdij"
                type="text"
                class="form-control"
                disabled
                :value="$store.state.chooseableAccesories.accessorySumPrice | currency"
              />
            </div>
          </div>

          <div class="form-group row mb-2">
            <label class="col-sm-6 fw-bold" for="eves_osszdij">A biztosítás kedvezményekkel csökkentett éves díja:</label>
            <div class="col-sm-6">
              <input
                id="eves_osszdij"
                type="text"
                class="form-control fw-bold"
                disabled
                :value="$store.state.kieg_emelt_eves_dij | currency"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <!-- <h1 class="h2 text-white">
          Az ön által megadott adatok alapján biztosítása az alábbi összegeket tartalmazza:
        </h1> -->
        <div class="customTrigger">
          <div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-group row mb-2">
                  <label class="col-sm-6" for="foepulet_dij">Főépület:</label>
                  <div class="col-sm-6">
                    <input
                      v-if="rebuild_building === 0"
                      id="foepulet_dij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="
                        $store.state.generalInfo.contractFor !== 3
                          ? $store.state.insuranceProperty.chosenInsurancePrice
                          : 0 | currency
                      "
                    />
                    <input
                      v-else
                      id="foepulet_dij"
                      type="text"
                      class="form-control"
                      disabled
                      value="Újjáépítési érték"
                    />
                  </div>
                </div>
                <div
                  class="form-group row mb-2"
                  v-if="
                    $store.state.insuranceSideBuildings.list.length > 0 &&
                      $store.state.generalInfo.contractFor !== 3
                  "
                >
                  <label class="col-sm-6" for="mellekepulet_dij">Melléképület(ek):</label>
                  <div class="col-sm-6">
                    <input
                      v-if="rebuild_building === 0"
                      id="mellekepulet_dij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.insuranceSideBuildings.chosenInsurancePrice | currency"
                    />
                    <input
                      v-else
                      id="mellekepulet_dij"
                      type="text"
                      class="form-control"
                      disabled
                      value="Újjáépítési érték"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-sm-6" for="foepulet_ingosag_dij">Főépület ingóság:</label>
                  <div class="col-sm-6">
                    <input
                      v-if="rebuild_ingosag === 0"
                      id="foepulet_ingosag_dij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="
                        $store.state.generalInfo.contractFor !== 2
                          ? mainPropertyInsurance
                          : 0 | currency
                      "
                    />
                    <input
                      v-else
                      id="foepulet_ingosag_dij"
                      type="text"
                      class="form-control"
                      disabled
                      value="Újrabeszerzési érték"
                    />
                  </div>
                </div>
              </div>
              <!-- <div v-show="false" class="col-md-4">
                <div class="form-group row mb-2">
                  <label class="col-sm-6" for="foepulet_ingosag_dij">Főépület ingóság:</label>
                  <div class="col-sm-6">
                    <input
                      v-if="rebuild_ingosag === 0"
                      id="foepulet_ingosag_dij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="
                        $store.state.generalInfo.contractFor !== 2
                          ? mainPropertyInsurance
                          : 0 | currency
                      "
                    />
                    <input
                      v-else
                      id="foepulet_ingosag_dij"
                      type="text"
                      class="form-control"
                      disabled
                      value="Újrabeszerzési érték"
                    />
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-group row mb-2">
                  <label class="col-sm-6 fw-bold" for="eves_alapdij_2">A biztosítás éves alapdíja:</label>
                  <div class="col-sm-6">
                    <input
                      id="eves_alapdij_2"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.chooseableAccesories.accessorySumPrice | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2" v-if="$store.state.page > 2">
                  <label class="col-sm-6 fw-bold" for="kieg_ossz_dij">A kiegészítők díja összesen:</label>
                  <div class="col-sm-6">
                    <input
                      id="kieg_ossz_dij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.eves_dij_plus | currency"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="$store.state.page >= 3">
              <div class="col-md-8">
                <!-- <div class="form-group row mb-2">
                  <label class="col-sm-6 fw-bold text-sm-end">Pótdíjak:</label>
                </div> -->
                <div class="form-group row mb-2" v-if="$store.state.engedmenyek.csekk">
                  <label class="col-sm-6 text-sm-end" for="postai_csekk_potdij">Postai csekk:</label>
                  <div class="col-sm-6">
                    <input
                      id="postai_csekk_potdij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.csekk | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2" v-if="$store.state.engedmenyek.havi">
                  <label class="col-sm-6 text-sm-end" for="havi_dijfiz_gyakorisag_potdij">Havi díjfizetési gyakoriság:</label>
                  <div class="col-sm-6">
                    <input
                      id="havi_dijfiz_gyakorisag_potdij"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.havi | currency"
                    />
                  </div>
                </div>

                <div class="form-group row mb-2">
                  <label class="col-sm-6 fw-bold text-sm-end">Kedvezmények:</label>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-sm-6 text-sm-end" for="e_komm_kedvezmeny">Elektronikus kommunikáció:</label>
                  <div class="col-sm-6">
                    <input
                      id="e_komm_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.elektronikus_kommunikacio | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-sm-6 text-sm-end" for="e_karrendezes_kedvezmeny">Elektronikus kárrendezés:</label>
                  <div class="col-sm-6">
                    <input
                      id="e_karrendezes_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.elektronikus_karrendezes | currency"
                    />
                  </div>
                </div>
                <div
                  class="form-group row mb-2"
                  v-if="$store.state.engedmenyek.fizetesi_mod_kedvezmeny"
                >
                  <label class="col-sm-6 text-sm-end" for="fizetesi_mod_kedvezmeny">Fizetési mód:</label>
                  <div class="col-sm-6">
                    <input
                      id="fizetesi_mod_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.fizetesi_mod_kedvezmeny | currency"
                    />
                  </div>
                </div>
                <div
                  class="form-group row mb-2"
                  v-if="$store.state.engedmenyek.dijfizetes_gyakorisag_kedvezmeny"
                >
                  <label class="col-sm-6 text-sm-end" for="dijfizetesi_gyakorisag_kedvezmeny">Díjfizetési gyakoriság:</label>
                  <div class="col-sm-6">
                    <input
                      id="dijfizetesi_gyakorisag_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.dijfizetes_gyakorisag_kedvezmeny | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2" v-if="$store.state.engedmenyek.eletkor_kedvezmeny">
                  <label class="col-sm-6 text-sm-end" for="eletkor_kedvezmeny">Életkor kedvezmény:</label>
                  <div class="col-sm-6">
                    <input
                      id="eletkor_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.eletkor_kedvezmeny | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2" v-if="$store.state.engedmenyek.kedvezmenykod">
                  <label class="col-sm-6 text-sm-end" for="kedvezmenykod_kedvezmeny">Kedvezmény:</label>
                  <div class="col-sm-6">
                    <input
                      id="kedvezmenykod_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.kedvezmenykod | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2" v-if="$store.state.engedmenyek.uzletpolitikai">
                  <label class="col-sm-6 text-sm-end" for="kockazati_kedvezmeny_kedvezmeny">Kockázati kedvezmény:</label>
                  <div class="col-sm-6">
                    <input
                      id="kockazati_kedvezmeny_kedvezmeny"
                      type="text"
                      class="form-control"
                      disabled
                      :value="$store.state.engedmenyek.uzletpolitikai | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-sm-6 fw-bold" for="eves_dij_ossz_2">A biztosítás kedvezményekkel csökkentett éves díja:</label>
                  <div class="col-sm-6">
                    <input
                      id="eves_dij_ossz_2"
                      type="text"
                      class="form-control fw-bold"
                      disabled
                      :value="$store.state.kieg_emelt_eves_dij | currency"
                    />
                  </div>
                </div>
                <div class="form-group row mb-2">
                  <label class="col-sm-6 fw-bold" for="valasztott_gyakorisag_dij"
                    >Az Ön által választott díjfizetési gyakoriság szerinti díj:</label
                  >
                  <div class="col-sm-6">
                    <input id="valasztott_gyakorisag_dij" type="text" class="form-control" disabled :value="paymentFrequentString" />
                  </div>
                </div>
              </div>
            </div>
            <small>
              A biztosítás éves alapdíja a következő lépésekben megadott adatok alapján módosulhat a
              pótdíjak és/vagy kedvezmények mértékével. A biztosítás éves díja minimum 10.000 Ft lehet.
            </small>
            <div class="row">
              <div class="col-sm-6">
                <save-link-button></save-link-button>
              </div>
              <div class="col-sm-6">
                <recalculate-button v-if="$store.state.page > 1"></recalculate-button>
                <dm-button v-if="$store.state.dm" :showFromPage="4"></dm-button>
                <request-pdf-buton v-else :showFromPage="4"></request-pdf-buton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </collapsible>
  </div>
</template>

<script>
import {parse as parseMoney} from 'vue-currency-input';
import RecalculateButton from './components/components/RecalculateButton.vue';
import RequestPdfButon from './components/components/RequestPdfButton.vue';
import DmButton from './components/components/DmButton.vue';
import Collapsible from './components/components/Collapsible.vue';
import SaveLinkButton from './components/components/SaveLinkButton.vue';
import 'animate.css';
import {mapFields} from 'vuex-map-fields';

export default {
  components: {
    RequestPdfButon,
    DmButton,
    Collapsible,
    SaveLinkButton,
    RecalculateButton,
  },

  data() {
    return {
      summaryPrice: 0,
      isCollapsed: false,
    };
  },
  computed: {
    ...mapFields([
      'generalInfo.rebuild_building',
      'generalInfo.rebuild_ingosag',
    ]),
    mainPropertyInsurance() {
      const acceptInsurance = this.$store.state.insurancePersonalGoods.acceptCalculatedInsurance;

      if (acceptInsurance) return this.$store.state.insurancePersonalGoods.calculatedInsurancePrice;

      return this.$store.state.insurancePersonalGoods.allGoodsPrice;
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == 'eves') stringFrequency = ' /év';
      else if (frequency == 'feleves') stringFrequency = ' /félév';
      else if (frequency == 'negyedeves') stringFrequency = ' /negyedév';
      else stringFrequency = ' /hó';
      return (
        this.$options.filters.currency(this.$store.state.gyakorisag_szerint_fizetendo_dij) +
        stringFrequency
      );
    },
    ClamIdentifie() {
      return this.$store.state.code;
    },
  },
  methods: {
    calculateSummaryPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'string') {
          const parsedInt = parseMoney(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }
      this.summaryPrice = price;
    },
    generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  .claim-identifier {
    max-width: max-content !important;
  }
}
$red: #e4002b;
.arrow-up {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  float: right;
  border-bottom: 20px solid white;
  // margin-left: 80%;
  margin-bottom: 5%;
  //display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  float: right;
  border-top: 20px solid white;
  //margin-left: 80%;
  margin-bottom: 5%;
  //display: inline-block;
  cursor: pointer;
}

b {
  float: right;
}
</style>
